// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detailSection .item.width100[data-v-69e1265d]{-webkit-box-flex:0 !important;-ms-flex:0 0 100% !important;flex:0 0 100% !important;width:100% !important}", ""]);
// Exports
module.exports = exports;
